import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetFiltersLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';

export const useCouponLandingPageFilters = () => {
  const session = useFullSession();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();
  const categoryIdentifier = useCategoryIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const liveAtFilter = useAppliedLiveAtFilter();
  const {promotionId} = useParams();

  return useGrpcRequest(
    CouponLandingPageService_GetFiltersLazy,
    {
      session: session!,
      targetGroup: targetGroupIdentifier,
      reductionsState,
      category: categoryIdentifier,
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      couponPromotionId: promotionId!,
    },
    {
      keepPreviousData: true,
      disabled: !session || !promotionId,
    },
  );
};
